<template>
    <div class="message-list-widget message-list">

        <div class="card">
            <spinner-until :condition="unreadMessages != null">
                <h3 class="card-header d-flex justify-content-between">
                    New Messages: {{ unreadMessages.length }}
                    <router-link class="link-light mt-2 mt-sm-0" :to="'/messages'">View All Messages
                        <b-icon-mailbox/>
                    </router-link>
                </h3>
                <div class="card-body overflow-auto" style="max-height: 300px"
                     v-if="unreadMessages && unreadMessages.length">
                    <table class="table table-striped">
                        <tr>
                            <th>From</th>
                            <th>Subject</th>
                            <th>Message</th>
                            <th>Actions</th>
                        </tr>
                        <tr v-for="(m, i) in unreadMessages" :key="i">
                            <td>
                                <strong>{{ m.fromUser.full_name }}</strong>
                            </td>
                            <td>{{ truncate(m.subject) }}</td>
                            <td>
                                {{ truncate(m.body) }}
                            </td>
                            <td style="white-space:nowrap;">
                                <button class="btn btn-secondary btn-sm mr-2 btn-icon"
                                        @click="viewItem(i)">
                                    <b-icon-eye/>
                                </button>
                                <button class="btn btn-secondary btn-sm mr-2 btn-icon"
                                        @click="setMessageAsRead(m)">
                                    <b-icon-envelope-open/>
                                </button>
                            </td>
                        </tr>
                    </table>
                </div>
                <div v-else class="card-body text-center" style="color: gray">
                    No Messages
                </div>
                <message-view-modal v-if="unreadMessages"
                                    :message="unreadMessages[viewMessage]"
                                    modalId="viewMessageModal"/>
            </spinner-until>
        </div>
    </div>
</template>

<script>
import * as _ from 'lodash'

export default {
    name: 'MessageListWidget',
    data () {
        return {
            messages: null,
            viewMessage: 0,
            loading: true
        }
    },
    async mounted () {
        const filters = {
            inboxForId: { field: 'inboxForId', type: 'hidden', value: this.$user.userId() }
        }
        this.messages = await this.$api.getItems(this, 'message', filters, {}, ['fromUser'])
        this.loading = false
    },
    methods: {
        viewItem (item) {
            this.$bvModal.show('viewMessageModal')
            this.viewMessage = item
        },
        truncate (str, length = 32, end = '...') {
            return str.length > length ? str.substring(0, length - end.length) + end : str
        },
        setMessageAsRead (message) {
            message.status = 'READ'
            this.$api.updateItem(this, 'message', message)
        },
    },
    computed: {
        unreadMessages () {
            return _.filter(this.messages, m => {
                return m.status === 'UNREAD'
            })
        },
    }
}
</script>
